import { useTheme, Box, Typography } from '@mui/material';
import { FileOptionsMenu } from './file-options-menu.js';
import { SingleDropzoneContainer, DropzoneFileContainer, OptionsFileButton, DROPZONE_ITEM_SIZE } from './styled.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { DeleteIcon, DocumentationIcon, CloudUpIcon } from '../../icons/index.js';

const SingleFileDropzone = props => {
  const {
    label,
    file,
    sx,
    optionsMenu,
    optionMenuLabels,
    downloadUrl,
    onRemoveFile,
    onReplace,
    backgroundColor = 'transparent'
  } = props;
  const theme = useTheme();
  const isCurrentFileAnImage = Boolean(file?.fileUrl);
  return /*#__PURE__*/jsxs(SingleDropzoneContainer, {
    sx: {
      backgroundColor: isCurrentFileAnImage ? backgroundColor : '',
      border: isCurrentFileAnImage ? `1px solid ${theme.palette.divider}` : '1px dashed',
      width: file ? 'max-content' : '100%',
      ...sx
    },
    children: [file && /*#__PURE__*/jsx(Fragment, {
      children: isCurrentFileAnImage ? /*#__PURE__*/jsxs(DropzoneFileContainer, {
        children: [onRemoveFile && onReplace && (optionsMenu ? /*#__PURE__*/jsx(FileOptionsMenu, {
          onRemove: onRemoveFile,
          onReplace: onReplace,
          downloadUrl: downloadUrl,
          labels: optionMenuLabels
        }) : /*#__PURE__*/jsx(OptionsFileButton, {
          onClick: onRemoveFile,
          children: /*#__PURE__*/jsx(DeleteIcon, {})
        })), /*#__PURE__*/jsx(Box, {
          component: "img",
          src: file.fileUrl,
          sx: {
            height: '100%',
            maxHeight: `${DROPZONE_ITEM_SIZE}px`,
            maxWidth: `${DROPZONE_ITEM_SIZE}px`,
            objectFit: 'contain'
          }
        })]
      }) : /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(DocumentationIcon, {}), /*#__PURE__*/jsx(Typography, {
          variant: "body02",
          children: file.file?.name ?? file.id
        })]
      })
    }), !file && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(CloudUpIcon, {}), /*#__PURE__*/jsx(Typography, {
        variant: "body02",
        children: label
      })]
    })]
  });
};

export { SingleFileDropzone };
